import { MaterialObject } from '../../../interfaces/Material.Interface';
import { Building } from '../../../redux/api/location';

// Legacy bundle threshold, used when the receiving building has no configured
// bundle_min_length (e.g. buildings created before the field existed).
export const DEFAULT_BUNDLE_MIN_LENGTH = 96;

export const getMaterialReceivingBuildingId = (
	material: MaterialObject,
	selectedBuildingId?: string
): string | null =>
	selectedBuildingId ??
	material.building_id ??
	material.material_order?.building?.id ??
	material.material_order_request?.building?.id ??
	null;

/**
 * The length (in inches) at/above which received material is treated as a bundle.
 * Per-building (West Bend = 48", others = 96"); DRF serializes the Decimal as a
 * string, so coerce to a number. Falls back to the legacy default when unset.
 */
export const getBundleMinLength = (
	building?: Pick<Building, 'bundle_min_length'>
): number => {
	const configured = Number(building?.bundle_min_length);
	return Number.isFinite(configured) && configured > 0
		? configured
		: DEFAULT_BUNDLE_MIN_LENGTH;
};

/** Whether a material of the given length should be received as a bundle. */
export const isBundleMaterial = (
	materialLength: number | null | undefined,
	bundleMinLength: number
): boolean => Number(materialLength ?? 0) >= bundleMinLength;
